define( function() {
	"use strict";

	// All support tests are defined in their respective modules.
	return {};
} );



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706012359-95877d6b9a-master/~/jquery/src/var/support.js
// module id = 81
// module chunks = 1